import { useEffect, useState } from "react";
import { TrendingUp, UserCheck, LayoutDashboard, ClipboardList, Users, CarTaxiFront, SlidersHorizontal, UserCog, MessageSquare, MapPinned, Route, QrCode } from "lucide-react";
import { DashboardShell } from "@/components/DashboardShell";
import { RevenuePanel } from "@/components/admin/RevenuePanel";
import { SettingsPanel } from "@/components/admin/SettingsPanel";
import { UsersPanel } from "@/components/admin/UsersPanel";
import { SmsPanel } from "@/components/admin/SmsPanel";
import { FleetOverview } from "@/components/fleet/FleetOverview";
import { BookingsPanel } from "@/components/fleet/BookingsPanel";
import { DriversPanel } from "@/components/fleet/DriversPanel";
import { VehiclesPanel } from "@/components/fleet/VehiclesPanel";
import { LiveMapPanel } from "@/components/fleet/LiveMapPanel";
import { ShiftReportPanel } from "@/components/fleet/ShiftReportPanel";
import { PostersPanel } from "@/components/fleet/PostersPanel";
import { api } from "@/lib/api";

const Approvals = ({ onChanged }) => <DriversPanel statusFilter="pending" onChanged={onChanged} />;

const BASE = [
  { key: "revenue", label: "Revenue", icon: TrendingUp, title: "Platform revenue", C: RevenuePanel },
  { key: "approvals", label: "Approvals", icon: UserCheck, title: "Driver approvals", C: Approvals },
  { key: "fleet", label: "Fleet overview", icon: LayoutDashboard, title: "Comfort Taxi fleet", C: FleetOverview },
  { key: "live", label: "Live map", icon: MapPinned, title: "Live fleet map", C: LiveMapPanel },
  { key: "shifts", label: "Shift report", icon: Route, title: "Daily shift & base return report", C: ShiftReportPanel },
  { key: "bookings", label: "Bookings", icon: ClipboardList, title: "All bookings", C: BookingsPanel },
  { key: "drivers", label: "Drivers", icon: Users, title: "All drivers", C: DriversPanel },
  { key: "vehicles", label: "Vehicles", icon: CarTaxiFront, title: "Fleet vehicles", C: VehiclesPanel },
  { key: "settings", label: "Fares & fees", icon: SlidersHorizontal, title: "Fares & fees", C: SettingsPanel },
  { key: "sms", label: "SMS alerts", icon: MessageSquare, title: "SMS ride alerts", C: SmsPanel },
  { key: "posters", label: "QR posters", icon: QrCode, title: "QR booking posters", C: PostersPanel },
  { key: "users", label: "Users", icon: UserCog, title: "All users", C: UsersPanel },
];

export default function AdminDashboard() {
  const [tab, setTab] = useState("revenue");
  const [pending, setPending] = useState(0);
  const loadPending = () => api.get("/fleet/drivers", { params: { status: "pending" } }).then((r) => setPending(r.data.length)).catch(() => {});
  useEffect(() => {
    loadPending();
  }, []);
  const items = BASE.map((i) => (i.key === "approvals" ? { ...i, badge: pending } : i));
  const cur = BASE.find((i) => i.key === tab);
  return (
    <DashboardShell
      roleLabel="Platform Admin"
      title={cur.title}
      subtitle="You run the platform · 5% from drivers + 5% from Comfort Taxi."
      items={items}
      active={tab}
      onChange={setTab}
    >
      <cur.C onChanged={loadPending} />
    </DashboardShell>
  );
}
